"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var cache_1 = require("../../../common/graphql/cache");
var JourneyTypes_1 = require("../../../../../../common/enum/JourneyTypes");
var ConfirmationReserveOnlineScreen_1 = require("./reserveOnline/ConfirmationReserveOnlineScreen");
var core_1 = require("@material-ui/core");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var ConfirmationScreenDataLayerHandler_1 = require("../../../common/utils/dataLayer/ConfirmationScreenDataLayerHandler");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var ReserveOnlineConfirmationScreen = function () {
    var delayConfirmationPage = core_1.useTheme().checkoutLite.confirmation.delayConfirmationPage;
    var _a = usePlatformConfig_1.default().platformConfig.priceDisplay.primary, subunitToUnit = _a.subunitToUnit, decimalScale = _a.decimalScale;
    var _b = react_1.useState(!!delayConfirmationPage), hidePage = _b[0], setHidePage = _b[1];
    react_1.useEffect(function () {
        cache_1.activeJourneyType(JourneyTypes_1.JourneyTypes.RESERVE_ONLINE);
        if (window.location !== window.top.location) {
            window.top.location = window.location;
        }
        else {
            setTimeout(function () {
                setHidePage(false);
            }, 1500);
        }
    }, []);
    var deal = useCheckoutContext_1.default().deal;
    react_1.useEffect(function () {
        if (deal) {
            ConfirmationScreenDataLayerHandler_1.default({ deal: deal, subunitToUnit: subunitToUnit, decimalScale: decimalScale });
        }
    }, [deal]);
    if (hidePage) {
        return null;
    }
    return <ConfirmationReserveOnlineScreen_1.default />;
};
exports.default = ReserveOnlineConfirmationScreen;
